import classNames from 'classnames';

import {useI18n} from '@udemy/i18n';
import {LearningTestimonial, LearningTestimonialCard} from '@udemy/react-discovery-units';
import {ContentArea, ContentGrid, ContentGridItem} from '@udemy/react-layout-components';

import styles from './testimonials.module.less';

interface TestimonialsProps {
    testimonials: LearningTestimonial[];
}

export const Testimonials = ({testimonials}: TestimonialsProps): JSX.Element | null => {
    const {gettext} = useI18n();

    if (testimonials.length === 0) {
        return null;
    }

    return (
        <div
            className={classNames(
                'ud-full-viewport-container',
                styles['testimonials-container-wrapper'],
            )}
        >
            <div className={styles['testimonials-container']}>
                <h2 className={classNames(styles['testimonials-title'], 'ud-heading-xxl')}>
                    {gettext('What other learners are saying')}
                </h2>
            </div>
            <ContentArea className={classNames('ud-container', styles['testimonials-container'])}>
                <ContentGrid className={styles['testimonials-grid']}>
                    {testimonials.map((testimonial) => (
                        <ContentGridItem defaultSpan={4} key={testimonial.id}>
                            <LearningTestimonialCard
                                size="large"
                                id={testimonial.id}
                                content={testimonial.content}
                                relatedUrl={testimonial.relatedUrl}
                                relatedUrlText={testimonial.relatedUrlText}
                                source={testimonial.source}
                                type={testimonial.type}
                                className={styles['testimonial-card']}
                            />
                        </ContentGridItem>
                    ))}
                </ContentGrid>
            </ContentArea>
        </div>
    );
};
